<template>
    <div class="recurrent" :class="stripe ? 'recurrent-stripe' : ''" v-if="isRecurringPayment">
        <div class="recurrent-title text-center" :class="stripe ? 'recurrent-title-stripe' : ''">
            <p v-if="endDate" tabindex="0">
                O valor será debitado {{ intervalText }} até {{ endDate }}
            </p>
            <p v-else tabindex="0">
                O valor será debitado {{ intervalText }}
            </p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        stripe: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        currentRoute: self => self.$route.matched[0].name,
        ...mapGetters({
            isRecurringPayment: 'recurrentPayment/isRecurringPayment',
            intervalText: 'recurrentPayment/getIntervalText',
            endDate: 'recurrentPayment/getEndDate'
        })
    }
};
</script>

<style lang="scss" scoped>
.recurrent {
    background: #EFF1F3;
    border-radius: 12px;
	padding: 12px;
}

.recurrent-title {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    color: #000;
    text-align: center;

	p {
		margin: 0;
	}
}
</style>
